import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import GymnastRoutines from '../../components/routines/GymnastRoutines';
import { hasFeature } from '../../hooks/useFeature';

export default function ChildRoutines() {
  const { user } = useAuth();
  const canSubmit = hasFeature(user, 'gymnastRoutines');
  return (
    <>
      <h1 className="child-app__title">Routines</h1>
      <GymnastRoutines gymnastId={user.id} canEdit={false} canSubmit={canSubmit} collapsible={false}
        emptyText={canSubmit ? "You don't have any routines yet. Press + Add to enter one, and your coach will check it." : "You don't have any routines yet."} />
    </>
  );
}
